module.exports = __webpack_public_path__ + "static/media/article-family-travel.0a4637e4.jpg";